export default {
  title: 'Showcases',
  description: 'Create beautiful presentations for your assets',
  create: 'Create Showcase',
  edit: 'Edit Showcase',
  delete: 'Delete Showcase',
  share: 'Share',
  preview: 'Preview',
  showcase: {
    name: 'Showcase Name',
    description: 'Description',
    url: 'URL',
    password: 'Password',
    passwordProtected: 'Password Protected',
    expiresAt: 'Expires At',
    neverExpires: 'Never Expires',
    views: 'Views',
    downloads: 'Downloads',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expired'
  },
  settings: {
    title: 'Showcase Settings',
    access: 'Access Control',
    design: 'Design',
    analytics: 'Analytics',
    seo: 'SEO'
  }
}